module.exports = __webpack_public_path__ + "img/pc.744dfb7b.png";